import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ManagmentService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiManagement/" + nameMethod, data, HEADERS);

  // proccessBoardOfDirectors(): Obtiene información del api de administración de cargue de cuentas contables
  proccessBoardOfDirectors = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // proccessStrategicMap() Obtiene información del api de administración del mapa estratégico de GC Balanced
  proccessStrategicMap = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getEntities(): Obtiene información del api de administración de las entidades que tienen acceso a GC Balanced
  getEntities = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // manageLog(): Obtiene información del api de administración del log
  manageLog = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getUsers(): Obtiene información del api de administración de los usuarios
  getUsers = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getRoutes(): Obtiene información del api de administración de las rutas
  getRoutes = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // buildReports() Evía información al API para generar reportes ya sean en PDF o XLSX
  buildReports(data: FormData, nameMethod: string): Observable<any> {
    return this.http.post(environment.apiPath + "ApiManagement/" + nameMethod, data, {
      reportProgress: true,
      responseType: "blob",
      observe: "events",
    });
  }

}
